import request from '@/utils/request'
/************************************* 党建工作 ***********************************/
// 获取党建工作分类
export function getPartyCategory(guid) {
  return request({
    url: '/front/partyBuilding/getCategory',
    method: 'get',
  })
}
// 获取党建工作分页数据
export function getPartyList(query) {
  return request({
    url: '/front/partyBuilding/getList',
    method: 'get',
    params: query
  })
}
// 获取党建详情
export function getPartyDetail(query) {
  return request({
    url: '/front/partyBuilding/getById',
    method: 'get',
    params: query
  })
}
// 获取党建推荐
export function getParRecommend(query) {
  return request({
    url: '/front/partyBuilding/infRecommend',
    method: 'get',
    params: query
  })
}
// 党建点赞
export function addPartLikes(query) {
  return request({
    url: '/front/partyBuilding/addLikes',
    method: 'get',
    params: query
  })
}

/************************************* 文化资讯 ***********************************/
export function getInformationCategory(guid) {
    return request({
      url: '/front/information/getCategory',
      method: 'get',
    })
  }
  // 获取文化资讯分页数据
  export function getInformationList(query) {
    return request({
      url: '/front/information/getList',
      method: 'get',
      params: query
    })
  }
  // 获取文化资讯详情
  export function getInformationDetail(query) {
    return request({
      url: '/front/information/getById',
      method: 'get',
      params: query
    })
  }
  // 获取文化资讯推荐
  export function getInfRecommend(query) {
    return request({
      url: '/front/information/infRecommend',
      method: 'get',
      params: query
    })
  }
  // 文化资讯点赞
  export function addInfoLikes(query) {
    return request({
      url: '/front/information/addLikes',
      method: 'get',
      params: query
    })
  }

    // 数字展厅点赞
    export function addNumLikes(query) {
      return request({
        url: '/front/digitalExhibition/addLikes',
        method: 'get',
        params: query
      })
    }

/************************************* 资源建设 ***********************************/
// 获取资源建设分类
export function getResourceCategory(query) {
    return request({
      url: '/front/resourceConstructionCategory/getList',
      method: 'get',
      params: query
    })
  }
  // 获取资源建设地区
export function getResArea(query) {
  return request({
    url: '/common/area/getAllArea',
    method: 'get',
    params: query
  })
}
  
  // 获取资源建设分页数据
  export function getResourceList(query) {
    return request({
      url: '/front/resourceConstruction/getList',
      method: 'get',
      params: query
    })
  }
  // 获取资源建设推荐
  export function getResRecommend(query) {
    return request({
      url: '/front/resourceConstruction/infRecommend',
      method: 'get',
      params: query
    })
  }
  // 资源建设点赞
  export function addResLikes(query) {
    return request({
      url: '/front/resourceConstruction/addLikes',
      method: 'get',
      params: query
    })
  }
  // 获取资源建设详情
  export function getResDetail(query) {
    return request({
      url: '/front/resourceConstruction/getById',
      method: 'get',
      params: query
    })
  }



/************************************* 收藏 ***********************************/
// 添加收藏
export function addCollect(data) {
  return request({
    url: '/front/collections/addCollection',
    method: 'post',
    params: data
  })
}
// 取消收藏
export function cancelCollect(data) {
  return request({
    url: '/front/collections/cancelCollection',
    method: 'post',
    params: data
  })
}
// 查询当前收藏总数
export function getCollectTotal(query) {
  return request({
    url: '/front/collections/collectionNum',
    method: 'get',
    params: query
  })
}
/************************************* 评论 ***********************************/
export function addComment(data) {
  return request({
    url: '/front/comment/saveComment',
    method: 'post',
    data: data
  })
}


